import ResearchPage from './ResearchPage';
export default ResearchPage;
